import React from 'react';
import PlaceOrder from '../PlaceOrder/PlaceOrder';

const OrderPage = () => {
    return (
        <>
            <PlaceOrder />
        </>
    );
};

export default OrderPage;